import { OptionTile } from "@manifesthhqinc/ui-library";
import { TitleLarge } from "../../../components/font";
import TransitionWrapper from "../../../components/transition-wrapper/TransitionWrapper";
import Container from "../../../layout/container";
import ScrollableContainer from "../../../layout/scrollable-container";
import { OptionTileContainer } from "./styles";
import { InvestmentPreference, UseHenryQuestionniareProps } from "../useHenryQuestionnaire";
import HeadingContainer from "../../../layout/heading-container";

const HenryQuestionnaireThree = (props: UseHenryQuestionniareProps) => {
  const { updateHenryQuestionnaire } = props;
  return (
    <TransitionWrapper>
      <ScrollableContainer name="henry-questionnaire-form-1">
        <Container>
          <HeadingContainer paneVariant="optionForm" withProgressBar>
            <TitleLarge>What sounds better when it comes to handling your investments?</TitleLarge>
          </HeadingContainer>
          <OptionTileContainer>
            <OptionTile
              name="yes"
              variant="clickthrough"
              appearance="secondary"
              onClick={() => updateHenryQuestionnaire({ investmentPreference: InvestmentPreference.SELF_DIRECTED })}
            >
              I want to make the decisions myself
            </OptionTile>
            <OptionTile
              name="no"
              variant="clickthrough"
              appearance="secondary"
              onClick={() =>
                updateHenryQuestionnaire({ investmentPreference: InvestmentPreference.GUIDED_OR_AUTOMATED })
              }
            >
              I’d rather get help or set it to run automatically
            </OptionTile>
          </OptionTileContainer>
        </Container>
      </ScrollableContainer>
    </TransitionWrapper>
  );
};
export default HenryQuestionnaireThree;
